import { LoaderCircle as LoaderCircleIcon } from 'lucide-react'
import { twMerge } from 'tailwind-merge'

export function LoaderCircle(
  props: React.ComponentProps<typeof LoaderCircleIcon>,
) {
  return (
    <LoaderCircleIcon
      {...props}
      className={twMerge('animate-spin', props.className)}
    />
  )
}
